/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2021
	12-03-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_pdf.onready();

	
!Wishlist

	none
	
*/

var specific_pdf = {};

(function () {

	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function () {

		// none

	};

	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************

	/**
	 * Download
	 * Download
	 * Download
	 * Download
	 */
	this.download = function (
		token
	) {

		window.location.href = globalUrl + '/statics/download-invoice/' + token;

	};

}).apply(specific_pdf); 